'use client';
'use strict';

var GNBList_parts = require('./GNBList.parts.js');

/**
 * GNB(Global Navigation Bar) 리스트 컴포넌트
 * @module GNBList
 * @property {Component} Root - GNB 리스트 컨테이너
 * @property {Component} UserInfo - 사용자 정보 컴포넌트
 * @property {Component} List - 메뉴 리스트 컴포넌트
 * @property {Component} SubList - 서브 메뉴 리스트 컴포넌트
 * @property {Component} Item - 메뉴 아이템 컴포넌트
 *
 * @example
 * // 기본 메뉴 리스트
 * <GNBList.Root type="main">
 *   <GNBList.List>
 *     <GNBList.Item>메뉴 1</GNBList.Item>
 *     <GNBList.Item>메뉴 2</GNBList.Item>
 *   </GNBList.List>
 * </GNBList.Root>
 *
 * @example
 * // 사용자 정보가 포함된 메뉴 리스트
 * <GNBList.Root type="user">
 *   <GNBList.UserInfo
 *     userId="사용자명"
 *     email="user@example.com"
 *     imgUrl="/profile.jpg"
 *   >
 *     <Button>프로필 수정</Button>
 *   </GNBList.UserInfo>
 *   <GNBList.List>
 *     <GNBList.Item>계정 설정</GNBList.Item>
 *     <GNBList.Item>알림 설정</GNBList.Item>
 *   </GNBList.List>
 *   <GNBList.SubList>
 *     <GNBList.Item>로그아웃</GNBList.Item>
 *   </GNBList.SubList>
 * </GNBList.Root>
 *
 * @example
 * // 선택 상태가 있는 메뉴 리스트
 * <GNBList.Root type="main">
 *   <GNBList.List>
 *     <GNBList.Item isSelected>현재 메뉴</GNBList.Item>
 *     <GNBList.Item onClick={() => handleNavigation('/other')}>
 *       다른 메뉴
 *     </GNBList.Item>
 *   </GNBList.List>
 * </GNBList.Root>
 */ const GNBList = {
    Root: GNBList_parts.Root,
    UserInfo: GNBList_parts.UserInfo,
    List: GNBList_parts.List,
    SubList: GNBList_parts.SubList,
    Item: GNBList_parts.Item
};

module.exports = GNBList;
